module.exports = __webpack_public_path__ + "images/vkb_bc_logo.svg?00cc2fa17866184f5f2405e5a4f5b3b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_bc_logo.svg
// module id = 33Hn
// module chunks = 0